import { __decorate } from "tslib";
import $ from 'jquery';
import Swiper from 'swiper';
import { throttle } from 'helpful-decorators';
import { getCurrentBreakpoint } from '../../../utils/breakpoint';
import { Breakpoint } from '../../../types/breakpoint';
export default class BlocksSlider {
    static swiper;
    static $slider = $('.js__blocks-slider');
    static $sliderContainer = $('.js__blocks-slider-container');
    static options = {
        slidesPerView: 'auto',
        resizeObserver: true,
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        const sliderOffsetPadding = this.calculateSliderPadding();
        this.swiper = new Swiper(this.$slider.get(0), {
            ...this.options,
            slidesOffsetBefore: sliderOffsetPadding,
            slidesOffsetAfter: sliderOffsetPadding,
        });
        $(window).on('resize', this.handleResize.bind(this));
    }
    static calculateSliderPadding() {
        const currentBreakpoint = getCurrentBreakpoint();
        return currentBreakpoint < Breakpoint.lg
            ? (this.$sliderContainer.outerWidth(true) - this.$sliderContainer.width()) / 2
            : 0;
    }
    static handleResize() {
        const sliderOffsetPadding = this.calculateSliderPadding();
        this.swiper.params.slidesOffsetBefore = sliderOffsetPadding;
        this.swiper.params.slidesOffsetAfter = sliderOffsetPadding;
        this.swiper.update();
    }
}
__decorate([
    throttle(300)
], BlocksSlider, "handleResize", null);
